<div class="option-content-particularity pointer" (click)="setWashOut()">
    <span class="option-title">Wash Out</span>

    <div class="actions">
        <input type="checkbox" [checked]="isWashOut" class="checkbox"/>
    </div>
</div>